import { SolidClose } from 'components/icon/solid'

import css from '../refinement-current-customized.module.scss'

type CurrentRefinementItemProps = {
  label: string | number
  filterName?: string
  handleRemove: () => void
}

const CurrentRefinementItem = ({ label, filterName, handleRemove }: CurrentRefinementItemProps) => {
  return (
    <li key={label} className={css.listItem}>
      {!!filterName && <span className={css.filterName}>{filterName}:</span>}
      <span className={css.filterLabel}>{label}</span>
      <SolidClose type="button" className={css.btnClose} onClick={handleRemove} />
    </li>
  )
}

export default CurrentRefinementItem
